/**
 * BattleRealtimeData 类型和 Schema 定义
 *
 * ⚠️ 注意: 此文件由脚本自动生成，请勿手动修改
 * 如需更新，请运行代码生成脚本
 */
import type { SchemaDefinition } from './_schema'
import type { BattleTeamData } from './battle_team_data'

/**
 * BattleRealtimeData
 */
export interface BattleRealtimeData {
  /** 红方战队数据 */
  red?: BattleTeamData
  /** 蓝方战队数据 */
  blue?: BattleTeamData
  /** 玩家数 */
  player_count?: number
  /** 成员数 */
  member_count?: number
  /** 围观数 */
  onlooker_count?: number
  /** 数据版本号 */
  version?: number
  /** 最后更新时间戳 */
  updated_at?: number
}

/**
 * BattleRealtimeData Schema
 */
export const BattleRealtimeDataSchema: SchemaDefinition = {
  properties: {
    red: {
      $ref: 'BattleTeamData',
      description: '红方战队数据',
      label: '红方战队数据',
    },
    blue: {
      $ref: 'BattleTeamData',
      description: '蓝方战队数据',
      label: '蓝方战队数据',
    },
    player_count: {
      description: '玩家数',
      format: 'int',
      type: 'integer',
      label: '玩家数',
    },
    member_count: {
      description: '成员数',
      format: 'int',
      type: 'integer',
      label: '成员数',
    },
    onlooker_count: {
      description: '围观数',
      format: 'int',
      type: 'integer',
      label: '围观数',
    },
    version: {
      description: '数据版本号',
      format: 'int',
      type: 'integer',
      label: '数据版本号',
    },
    updated_at: {
      description: '最后更新时间戳',
      format: 'int',
      type: 'integer',
      label: '最后更新时间戳',
    },
  },
  type: 'object',
}
